<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="vx-row mb-4">
      <div class="w-full md:w-1/3 vx-col">
        <radial-chart :item="item" />
      </div>
      <div class="w-full md:w-2/3 vx-col">
        <bar-chart :item="item" />
      </div>
    </div> 
  </div>
</template>

<script>
import BarChart from './components/BarChart.vue'
import RadialChart from './components/RadialChart.vue'

export default {
  components: {
    BarChart,
    RadialChart
  },
  data(){
    return {
      items: [
        {
          type: 'investment',
          title: 'Realisasi Investasi',
          defaultYear: 2023,
          target: {
            title: 'Target Investasi ',
            color: '#00b5b5'
          },
          realization: {
            title: 'Realisasi Investasi ',
            color: '#00db89'
          },
          barThickness: 40
        },
        {
          type: 'imb',
          title: 'Realisasi Retribusi IMB',
          defaultYear: 2023,
          target: {
            title: 'Target Retribusi IMB ',
            color: '#5cd6d6'
          },
          realization: {
            title: 'Realisasi Retribusi IMB ',
            color: '#1aa3ff'
          },
          barThickness: 30
        },
        {
          type: 'rptka',
          title: 'Realisasi Retribusi RPTKA',
          defaultYear: 2023,
          target: {
            title: 'Target Retribusi RPTKA ',
            color: '#00b5b5'
          },
          realization: {
            title: 'Realisasi Retribusi RPTKA ',
            color: '#00db89'
          },
          barThickness: 30
        },
        {
          type: 'siupmb',
          title: 'Realisasi Retribusi SIUP-MB',
          defaultYear: 2021,
          target: {
            title: 'Target Retribusi SIUP-MB ',
            color: '#ffd11a'
          },
          realization: {
            title: 'Realisasi Retribusi SIUP-MB ',
            color: '#ff5050'
          },
          barThickness: 30
        },
        {
          type: 'distraction',
          title: 'Realisasi Retribusi Izin Gangguan',
          defaultYear: 2017,
          target: {
            title: 'Target Retribusi Izin Gangguan ',
            color: '#5cd6d6'
          },
          realization: {
            title: 'Realisasi Retribusi Izin Gangguan ',
            color: '#1aa3ff'
          },
          barThickness: 30
        },
        {
          type: 'animal_butcher',
          title: 'Realisasi Retribusi Rumah Potong Hewan',
          defaultYear: 2018,
          target: {
            title: 'Target Retribusi Rumah Potong ',
            color: '#ffd11a'
          },
          realization: {
            title: 'Realisasi Retribusi Rumah Potong ',
            color: '#ff5050'
          },
          barThickness: 30
        },
      ]
    }
  }
}
</script>